
(function () {
  var PHONE_SVG = '<svg viewBox="0 0 48 48" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" style="width:100%;height:100%;display:block;"><path d="M11.5557 10C11.1431 10 10.7478 10.1643 10.4561 10.4561C10.1643 10.7478 10 11.1431 10 11.5557C10.0001 26.1622 21.8378 37.9999 36.4443 38C36.8569 38 37.2522 37.8357 37.5439 37.5439C37.8357 37.2522 38 36.8569 38 36.4443V31.0156C38 30.6031 37.8357 30.2077 37.5439 29.916C37.2522 29.6243 36.8569 29.46 36.4443 29.46C34.5001 29.4599 32.6181 29.1487 30.876 28.5732C30.6051 28.4857 30.315 28.4743 30.0381 28.54C29.7612 28.6058 29.5073 28.7464 29.3047 28.9463L25.8818 32.3691C21.4967 30.0814 17.9186 26.5033 15.6309 22.1182L19.0693 18.6953C19.2692 18.4927 19.4098 18.2388 19.4756 17.9619C19.5413 17.685 19.5299 17.3949 19.4424 17.124C18.8669 15.3819 18.5557 13.4999 18.5557 11.5557C18.5557 11.1431 18.3913 10.7478 18.0996 10.4561C17.8079 10.1643 17.4126 10 17 10H11.5557Z" fill="white"/></svg>';

  function replaceBrandwiseChatIcon(btn) {
    var existingSvg = btn.querySelector('svg');
    if (existingSvg) {
      existingSvg.outerHTML = PHONE_SVG;
    }
    btn.setAttribute('data-phone-icon-replaced', 'true');
  }

  function tryReplaceChatIcon() {
    var btn = document.getElementById('brandwise-chat-button');
    if (btn && !btn.getAttribute('data-phone-icon-replaced')) {
      replaceBrandwiseChatIcon(btn);
      return true;
    }
    return false;
  }

  if (!tryReplaceChatIcon()) {
    var observer = new MutationObserver(function () {
      if (tryReplaceChatIcon()) {
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();

document.addEventListener('DOMContentLoaded', function () {
  var addonBtns = document.querySelectorAll('[data-addons-add-btn]');

  addonBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      

      // Main product ID
      var mainIdEl = document.querySelector('[data-pro-form] input[name="id"]');
      var mainId   = mainIdEl ? mainIdEl.value : null;

      // Addon product ID (from the button's parent form)
      var addonForm = btn.closest('form');
      var addonIdEl = addonForm ? addonForm.querySelector('input[name="id"]') : null;
      var addonId   = addonIdEl ? addonIdEl.value : null;

      if (!mainId || !addonId) {
        console.warn('Missing product IDs');
        return;
      }

      // Build line items
      var items = [
        { id: mainId,  quantity: 1 },
        { id: addonId, quantity: 1 }
      ];

      // Add to cart via AJAX API
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          console.log('Added products:', data);
          // Optional: update cart drawer or redirect
          window.location.href = '/cart'; 
        })
        .catch(function (err) {
          console.error('Cart add failed:', err);
        });
    });
  });
});

